import { Component, OnInit } from '@angular/core';
import { PatientService } from 'src/app/shared/patient-service/patient.service';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { map, take } from 'rxjs/operators';
import { UrlModal } from 'src/app/shared/url.model';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-patdashboard',
  templateUrl: './patdashboard.component.html',
  styleUrls: ['./patdashboard.component.css']
})
export class PatdashboardComponent implements OnInit {
  docArray:any;
  userToken: string;
  token: string;
  id: string;
  allTotal: number;
  page: number;
  totalItems: number;
  serverip: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private patservice:PatientService,
    private authService: AuthService,
    ) { }

  ngOnInit(): void {
    this.serverip =UrlModal._URL;
    this.getDoctorFromDb(this.page)
  }
  getDoctorFromDb(page){
    this.patservice.getDoctorFromDb(this.token, page).subscribe((res) => {
      if (res.docData && res.docData.length > 0) {      
        this.docArray = res.docData;
        console.log('dokData',this.docArray)
        this.page = +res.page;
        this.totalItems = res.total;
        if (this.page === 1) {
          this.allTotal = res.total;
        }
       
      }
    });
  
  }
}
